export default __webpack_public_path__ + "assets/icons/mark_question.5422f988.svg";